import { FeatureResolver } from "./exchanges";

type Flags = {};

const flags: Flags = {};
export const flagSettings = flags as FeatureResolver;
